import React from 'react';
import { Heart, LogOut, Palette } from 'lucide-react';
import { ThemeConfig } from '../types';

interface HeaderProps {
  theme: ThemeConfig;
  onToggleTheme: () => void;
  onSignOut: () => void;
}

const Header: React.FC<HeaderProps> = ({ theme, onToggleTheme, onSignOut }) => {
  return (
    <header className={`${theme.primary} border-b-2 ${theme.border} sticky top-0 z-50 backdrop-blur-sm bg-opacity-90`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Heart className={`w-8 h-8 ${theme.text}`} fill="currentColor" />
            <h1 className={`text-2xl font-bold ${theme.text} hidden md:block`}>
              Yuk's Virtual Space
            </h1>
          </div>
          
          <div className="flex items-center gap-3">
            <button
              onClick={onToggleTheme}
              className={`p-2 rounded-lg ${theme.accent} text-white ${theme.accentHover} transition-all`}
              title="Toggle theme"
            >
              <Palette className="w-5 h-5" />
            </button>
            <button
              onClick={onSignOut}
              className={`p-2 rounded-lg ${theme.accent} text-white ${theme.accentHover} transition-all`}
              title="Sign out"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;